import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function ZohoEntityPeriodSelector({ periods, hasPeriods, value, onChange }) {
  if (!hasPeriods) return null;

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[200px] h-8 text-xs" data-testid="period-selector">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="_latest">Latest Submission</SelectItem>
        {periods.map(function(p) {
          return <SelectItem key={p} value={p}>{p}</SelectItem>;
        })}
      </SelectContent>
    </Select>
  );
}
